module.exports = __webpack_public_path__ + "static/media/7.aa27d480.png";